import { StartSimulationClickedProps } from '@/global/utils/analytics-events/types/leadGenerationEvens'
import {
  ButtonType,
  EventName
} from '@/global/utils/analytics-events/types/common'
import { dispatchEvent } from '@/global/utils/analytics-events'
import { ButtonClickedProps } from '@/global/utils/analytics-events/types/generalEvents'
import * as urls from '@/global/constants/routes'

const menuDrawerId = 'menu_drawer'

/*
 * `aria-controls` recebe um IDREF, que nao aceita espaco nem acento, entao o
 * titulo do item do menu vira um id normalizado.
 */
const getMenuPanelId = (title: string) =>
  `navbar-menu-panel-${title
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')}`

/*
 * A ordem e os rotulos acompanham o rodape do menu em producao. O `name` e o
 * nome do arquivo em /images/socials.
 */
const LIST_SOCIAL_ICONS = [
  {
    name: 'linkedin',
    label: 'Linkedin',
    url: urls.LINKEDIN_URL
  },
  {
    name: 'instagram',
    label: 'Instagram',
    url: urls.INSTAGRAM_URL
  },
  {
    name: 'youtube',
    label: 'Youtube',
    url: urls.YOUTUBE_URL
  }
]

const sendStartSimulatorAnalyticEvent = (buttonName: string) => {
  const buttonStartSimulation: StartSimulationClickedProps = {
    eventName: EventName.START_SIMULATION_CLICKED,
    buttonType: ButtonType.NEW_PAGE,
    buttonName
  }
  dispatchEvent(buttonStartSimulation)
}

const sendButtonClickedAnalyticEvent = (buttonName: string) => {
  const buttonClickedEvent: ButtonClickedProps = {
    eventName: EventName.BUTTON_CLICKED,
    buttonType: ButtonType.NEW_PAGE,
    buttonName
  }
  dispatchEvent(buttonClickedEvent)
}

export {
  getMenuPanelId,
  menuDrawerId,
  LIST_SOCIAL_ICONS,
  sendButtonClickedAnalyticEvent,
  sendStartSimulatorAnalyticEvent
}
